import './App.css';
import Home from './main_page/Home';
import { BorderBeam } from "./@/components/magicui/border-beam";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

//import Card1 from './template/Card1';
 //import Card from './template/Card1';
 //import T0 from "./template_0/T0";


function App() {
  return (

    <Router>
    <BorderBeam size={350} duration={12} delay={9} />
    <div className="App">
      <Routes>

        <Route path="/" element={<Home />} />
        {/* <Route path="/t1" element={<Card />} /> */}
        {/* <Route path="/t2" element={<T0 />} /> */}
      </Routes>

    </div>
    
    </Router>
  );
}

export default App;
